import { render } from "./ErrorIcon.vue?vue&type=template&id=2da3a2a6&lang=true"
import script from "./ErrorIcon.vue?vue&type=script&lang=js"
export * from "./ErrorIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/assets/toast/ErrorIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2da3a2a6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2da3a2a6', __exports__)) {
    api.reload('2da3a2a6', __exports__)
  }
  
  module.hot.accept("./ErrorIcon.vue?vue&type=template&id=2da3a2a6&lang=true", () => {
    api.rerender('2da3a2a6', render)
  })

}


export default __exports__